/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { elementHasClassName, toggleMultipleClasses } from './util.js';
// import { default_ajax_error_handler } from './fetch-util.js';
// import { getFromSession, setInSession } from './session-util.js';
// import { mj } from './page-mj.js';
import { $ } from '../other/jquery-hooked.js';
// import { mjt } from './i18ntexts.js';



let globalSelectionCounter = 0;


function SelectionClassesObserver( rootElement, cascadeClassesToItem ) {

	if( !window.MutationObserver ) {
		return;
	}

	const observerOptions = {
		attributes: true,
		childList: false,
		characterData: false,
		subtree: true,
		attributeOldValue: false,
		attributeFilter: ['class']
	};

	const doLazyDisconnect = true;//!! cascadeClassesToItem;

	const thisWidget = this;
	this.rootElement = rootElement;
	this.observer = new MutationObserver( function( mutations ) {
		// disconnect observer -> avoid callbacks for our own changes
		let _lazy_disconnected = false;

		mutations.forEach( function _observe_mutation( m ) {
			if( m.type==='attributes' && m.attributeName==='class' ) {
				const targetElem = m.target;
				if( targetElem.nodeName==='DIV' && elementHasClassName(targetElem,'smn') ) {

					if( doLazyDisconnect && _lazy_disconnected===false ) {
						_lazy_disconnected = true;
						thisWidget.observer.disconnect();
					}

					const isSelecting = elementHasClassName(targetElem,'ui-selecting');
					const isSelected = elementHasClassName(targetElem,'ui-selected');

					const $target = $(targetElem);
					// console.log({ tidx: $target.hasClass('lb-item') ? $target.attr('mj_tidx') : $target.closest('.item').attr('mj_tidx'), isSelecting, isSelected });

					if( isSelecting || isSelected ) {
						// track selectedCounter -> so, we can choose the item from a list, which was selected as last!
						$target.data('selCnt',++globalSelectionCounter);
					}

					if( cascadeClassesToItem ) {
						const $item = $target.closest('.item');
						toggleMultipleClasses(
							$item,
							{
								'item-selecting': isSelecting,
								'item-selected': isSelected,
							}
						);
					}
				}
			}
		} );

		if( doLazyDisconnect && _lazy_disconnected ) {
			// reconnect observer
			thisWidget.observer.observe(thisWidget.rootElement,observerOptions);
		}

	} );

	// first time connect observer
	this.observer.observe(this.rootElement,observerOptions);
}


SelectionClassesObserver.prototype = {
	disconnect: function() {
		this.observer.disconnect();
	}
};


export {
	SelectionClassesObserver,
};


